import type { RefCallback, RefObject } from "react";
import type { IButtonSize } from "../components/Button/types";
import type { ITextFieldSize } from "../types";

export const textFieldButtonSize: Record<ITextFieldSize, IButtonSize> = {
  sm: "xs",
  md: "sm",
  lg: "md",
};

/**
 * Merges multiple refs into a single ref callback
 * Handles both callback refs and mutable ref objects
 * @param refs Array of refs to merge (can include undefined/null)
 * @returns A ref callback that will call all provided refs
 */

export function mergeRefs<T = any>(
  ...refs: (RefObject<T | null> | RefCallback<T> | null | undefined)[]
) {
  return (node: T | null) => {
    refs.forEach((ref) => {
      if (ref) {
        if (typeof ref === "function") {
          ref(node);
        } else {
          ref.current = node;
        }
      }
    });
  };
}

export function composeEventHandlers<E>(
  theirs?: (e: E) => void,
  ours?: (e: E) => void,
) {
  return (e: E) => {
    theirs?.(e);

    if (!(e as any).defaultPrevented) {
      ours?.(e);
    }
  };
}
